import React from 'react'
import { useDispatch } from 'react-redux'
import { getAccountStatus, linkAccount } from 'account'
import { openConnectionModal, setCurrentChannel } from '../integrationsSlice'

export default function AccountStatus({ account }) {
  const dispatch = useDispatch()
  const { tokenExpired } = getAccountStatus(account)

  if (!tokenExpired) return <div className="tw-text-green-600">Good</div>

  // Shipsurance has no OAuth relink URL; reconnecting means re-entering the
  // partner policy credentials, so route the CTA to its connection modal.
  const handleReconnect = () => {
    if (account.channel === 'Shipsurance') {
      dispatch(setCurrentChannel({ channel: 'Shipsurance' }))
      dispatch(openConnectionModal())
      return
    }
    linkAccount(account, true)
  }

  return (
    <div>
      <div
        className="tw-cursor-pointer tw-underline tw-underline-offset-4 tw-text-blue-600"
        onClick={handleReconnect}
      >
        {account.channel === 'Shipsurance' ? 'Expired — reconnect' : 'Relink needed'}
      </div>
    </div>
  )
}
